import { create } from "zustand";

const LoadingStore = create((set) => ({
  loading: false,
  setLoading: (setLoadingState) => {
    set({ loading: setLoadingState }), console.log("loading changed:", setLoadingState);
  },
  removeLoading: () => set({ loading: "" }),
}));

export default LoadingStore;